export default __webpack_public_path__ + "static/media/google-icon.f1fe7ad2.svg";